import './Pdftoword.css';  
import api from '../../jobsite/Components/api.js';  
import Loader from '../../Utils/Loader.js';
import { useState } from 'react'; 
import SharePage from '../SharePage.js';
let Pdftoword=()=>{  
    let [processing, setprocessing] = useState(null)
    let [dwlnlink, setdwlnlink] = useState(null); 
    

    let handelinputchange=async(e)=>{
        setprocessing("Please wait while its Converting...");
        document.querySelector(".loading").style.display="block";
 
        document.querySelector(".inputcont").style.display="none";
        let pdftowordformdata= new FormData();
        let file = e.target.files[0];
        if(file && file.type === 'application/pdf'){
   
            pdftowordformdata.append('pdffile',file);
            const response = await api.post('https://makeeasyway.in/converters/convertpdftoword.php', pdftowordformdata); 
            setprocessing("");
            if(response.data.Status === "Converted successfully please Download"){ 
                document.querySelector(".loading").style.display="none";
                document.querySelector(".sucmsg").innerHTML=response.data.Status;
                document.querySelector(".akak").style.display="block";
                setdwlnlink(response.data.downloadUrl);
                
                
            }else{
                document.querySelector(".akak").style.display="none";
                document.querySelector(".loading").style.display="none";
                document.querySelector(".error").style.display="block";
                setprocessing(response.data.Status);
                




            }
           
            
           

        
        }
    }
  
    
   
    return(
        <div className='pdfwordconvmaincont'>
            <h3 className='pdfwordconvherding'>Convert from pdf to word</h3>
             <p className='loading'><Loader msg={processing}/></p> 
             <p style={{display:"none",textAlign:"center", color:"red", fontSize:"25px"}} className='error'>{processing}<a style={{display:"inline-block", textDecoration:"underline", margin:"20px"}} href='/Converter'>Home</a></p>

            <div style={{display:"none"}} className='akak'> 
                <p className='sucmsg'></p>
                <p ><a href={dwlnlink} className='dlnlink'>Downaload File</a></p>
                 <SharePage path='/Converter/pdftoword' title='Check out this awesome pdf to word converter tool' description="Convert your pdf into Editable word formate"/>
            </div>

            <div className='inputcont'>
                <label className='pdfwordlabel' htmlFor='pdfword'>Select PDF File+</label>
                <input type='file' onChange={handelinputchange} id='pdfword' style={{display:"none"}}/>
            </div> 
            
          
 
        </div> 
    );
}

export default Pdftoword;